import { render } from "./SignOutBarComponent.vue?vue&type=template&id=7028b2f4&ts=true"
import script from "./SignOutBarComponent.vue?vue&type=script&lang=ts"
export * from "./SignOutBarComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__